import { createContext } from 'react'

export const AsyncTasks = createContext()
